import {HttpClient, HttpHeaders}            from "@angular/common/http";
import {Injectable}                         from '@angular/core';

import {AngularQuery}                       from "../query/angularquery";
import {RssmanagerItem}                     from "./rssmanageritem";

import {Observable}                         from "rxjs/Observable";
import {map}                                from "rxjs/operators";



@Injectable()
export class FeedService {


	/**
	 * Initialize the object.
	 *
	 * @param http  Handles HTTP communications.
	 */
	constructor(

		protected http: HttpClient

	) {}


	/**
	 * Delete the specified item and return success or failure.
	 *
	 * @param id  The ID of the item to delete.
	 * @return {Observable<Boolean>}
	 */
	deleteItem(id:number): Observable<Boolean> {

		let query: AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_RSSMANAGER, id.toString());
		query.useCacheBuster(false);
		query.useParams(false);
		let url:string = query.getUrl();

		return this.http
			.delete<Boolean>(url)
			.pipe(
				map(() => {
					return true;
				})
			);

	}


	/**
	 * This is used in the rssmanager page to retrieve all the RssmanagerItem objects.
	 *
	 * @param order_field    Which field to sort by.
	 * @param sort_order     Sort ascending or descending.
	 * @returns {Observable<RssmanagerItem[]>}   An Observable array of RssmanagerItem objects.
	 */
	getRssmanagerItems(order_field:string = 'title', sort_order:string = 'asc'): Observable<RssmanagerItem[]> {

		let query: AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_RSSMANAGER);
		query.setPerPage(100);
		query.addParameter('order_field', order_field);
		query.addParameter('sort_order', sort_order);

		let url:string = query.getUrl();

		return this.http
			.get<RssmanagerItem[]>(url);

	}


	/**
	 * Perform a POST statement for an item in the Rssmanager table.
	 *
	 * @param url    The URL of the POST to modify an item.
	 * @param body   The body of the POST statement; defaults to null.
	 * @return {Observable<RssmanagerItem>}
	 */
	postItem(url:string, body:string = null): Observable<RssmanagerItem> {

		// Warn them that JSON is coming.
		let headers = new HttpHeaders().append('Content-Type', 'application/json');
		return this.http
			.post<RssmanagerItem>(url, body, { headers: headers });

	}


	/**
	 * Perform a PUT statement for an item in the Rssmanager table.
	 *
	 * @param url    The URL of the PUT to modify an item.
	 * @param body   The body of the PUT statement; defaults to null.
	 * @return {Observable<RssmanagerItem|Null>}
	 */
	putItem(url:string, body:string = null): Observable<RssmanagerItem> {

		// Warn them that JSON is coming.
		let headers = new HttpHeaders().append('Content-Type', 'application/json');
		return this.http
			.put<RssmanagerItem>(url, body, { headers: headers });

	}

}



// WEBPACK FOOTER //
// ./src/app/services/feed/feed.service.ts